import React from 'react';

const Footer = () => {
    return (
        <div className="pageFooterContainer">
            <span>nVisio v6.0</span>
            <span style={{ opacity: 0.4 }}>|</span>
            <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <a href="https://www.blackbee.fr" style={{ textDecoration: 'none', color: 'inherit' }}>Powered by</a>
                <a href="https://www.blackbee.fr" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center' }}>
                    <div id="Blackbee" />
                </a>
            </span>
            <span style={{ opacity: 0.4 }}>|</span>
            <span>
                <a href="/privacy-policy">Confidentialité</a>
                <span style={{ opacity: 0.4, margin: '0 8px' }}>·</span>
                <a href="/terms-of-service">CGU</a>
            </span>
        </div>
    );
};

export default Footer;